import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import UsersPage from './users/UsersPage';
import './users/users.css';
import './users/brand.css';

export default function Users() {
  const { user } = useAuth();
  useEffect(() => { document.body.classList.add('users-brand'); return () => document.body.classList.remove('users-brand'); }, []);
  return <UsersPage superAdmin={user?.admin_role === 'super_admin'} />;
}
